"use client";

import { articles } from "@/data/article";
import { PostSlider } from "@/components/blog/PostSlider";
import Link from "next/link";
import { useInView } from "react-intersection-observer";

export const Blog = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  const csrArticles = articles
    .filter((article) => article.category.toLowerCase() == "community action")
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    );

  return (
    <div
      id="blog"
      className="relative flex flex-col w-full h-fit items-center justify-start"
    >
      <svg
        ref={ref}
        className={`size-[125px] absolute top-[15%] left-[5%] ${inView ? "scale-100" : "scale-0"} transition-all duration-[1.5s] ease-in-out -z-50`}
        viewBox="0 0 125 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.35"
          d="M62.5 0L68.7983 29.3301C71.6894 42.7936 82.2064 53.3106 95.6699 56.2017L125 62.5L95.6699 68.7983C82.2064 71.6894 71.6894 82.2064 68.7983 95.6699L62.5 125L56.2017 95.6699C53.3106 82.2064 42.7936 71.6894 29.3301 68.7983L0 62.5L29.3301 56.2017C42.7936 53.3106 53.3106 42.7936 56.2017 29.3301L62.5 0Z"
          fill="#FFBD58"
        />
      </svg>

      {/* Blog CSR Content */}
      <div className="flex flex-col gap-12 md:gap-16 items-center justify-center w-full px-6 py-12 lg:px-0 lg:pt-28 lg:pb-14">
        {/* Heading */}
        <div className="flex flex-col gap-4 items-center px-2">
          {/* Heading */}
          <div className="flex flex-col gap-1.5">
            <h2 className="text-base md:text-xl text-natura-darker-1 text-center font-serifText">
              Blog
            </h2>
            <h2 className="text-natura-primary text-3xl md:text-4xl lg:text-5xl text-center font-serifText">
              Natura Community Action
            </h2>
          </div>
          <p className="text-base md:text-base lg:text-lg text-center max-w-[870px] font-nunito">
            Kami percaya bahwa kesehatan gigi yang baik adalah bagian penting
            dari kesejahteraan hidup, dan kami terus berkontribusi menciptakan
            senyum sehat dan indah di tengah masyarakat.
          </p>
        </div>

        {/* Post slider */}
        <div className="flex flex-col items-center justify-center gap-8 md:gap-12 ">
          {/* <PostSlider data={csrArticles} /> */}
          <Link
            href={"/article"}
            className="flex items-center justify-center px-6 py-3 rounded-full bg-natura-primary hover:bg-natura-hover active:bg-natura-pressed transition-all duration-150 w-fit font-nunito text-white font-normal cursor-pointer text-xs md:text-base leading-normal"
          >
            Lihat Kegiatan Lainnya
          </Link>
        </div>
      </div>
    </div>
  );
};
